// extracted by mini-css-extract-plugin
export default {"name-cell":"_name-cell_IoB5ex","name-cell-not-sticky":"_name-cell-not-sticky_99uTow"};